@if (visibleJobs().length > 0) {
  <app-notification-card
    iconName="work_history"
    [title]="'Background Jobs (' + visibleJobs().length + ' active)'"
    [compact]="true">
    @for (snap of visibleJobs(); track snap.block.job_id) {
      <div
        class="d-flex align-items-center gap-2 py-1"
        (click)="scrollToJob(snap.block.job_id)"
        role="button"
        tabindex="0"
        (keydown.enter)="scrollToJob(snap.block.job_id)"
      >
        <span class="flex-grow-1 mat-font-label-sm text-truncate">{{ snap.block.display_name ?? snap.block.job_id }}</span>
        @if (snap.progress; as progress) {
          <mat-progress-bar
            mode="determinate"
            [value]="progress.phases_total > 0 ? (progress.phases_completed / progress.phases_total) * 100 : 0"
            class="bg-job-panel__bar flex-shrink-0"
          />
          <span class="mat-font-label-sm mat-text-on-surface-variant flex-shrink-0">
            {{ progress.phases_completed }}/{{ progress.phases_total }}
          </span>
        }
        @switch (snap.run_status) {
          @case ('success') { <mat-icon class="mat-text-primary flex-shrink-0">check_circle</mat-icon> }
          @case ('error')   { <mat-icon class="mat-text-error flex-shrink-0">error</mat-icon> }
          @default          { <mat-icon class="mat-text-on-surface-variant flex-shrink-0">pending</mat-icon> }
        }
      </div>
    }
  </app-notification-card>
}
